import { FIELD_TYPES } from '../constants';
import { formatCheckboxGroup } from '../fields/checkbox-group/checkbox-group-preview';
import { formatCheckbox } from '../fields/checkbox/checkbox-preview';
import { formatContactsAddress } from '../fields/contacts-address/contacts-address-preview';
import { formatContactsCompany } from '../fields/contacts-company/contacts-company-preview';
import { formatContactsEmail } from '../fields/contacts-email/contacts-email-preview';
import { formatContactsBirthdate } from '../fields/contacts-birthdate/contacts-birthdate-preview';
import { formatContactsFirstName } from '../fields/contacts-first-name/contacts-first-name-preview';
import { formatContactsLastName } from '../fields/contacts-last-name/contacts-last-name-preview';
import { formatContactsPhone } from '../fields/contacts-phone/contacts-phone-preview';
import { formatContactsPosition } from '../fields/contacts-position/contacts-position-preview';
import { formatContactsSubscribe } from '../fields/contacts-subscribe/contacts-subscribe-preview';
import { formatContactsTaxId } from '../fields/contacts-tax-id/contacts-tax-id-preview';
import { formatDateInput } from '../fields/date-input/date-input-preview';
import { formatDateTimeInput } from '../fields/date-time-input/date-time-input-preview/date-time-input-preview';
import { formatTimeInput } from '../fields/time-input/time-input-preview';
import { formatDropdown } from '../fields/dropdown/dropdown-preview';
import { formatEcomCompanyName } from '../fields/ecom-company-name/ecom-company-name-preview';
import { formatEcomEmail } from '../fields/ecom-email/ecom-email-preview';
import { formatEcomPhone } from '../fields/ecom-phone/ecom-phone-preview';
import { formatNumberInput } from '../fields/number-input/number-input-preview';
import { formatQuizLongText } from '../fields/quiz-long-text/quiz-long-text-preview';
import { formatQuizMultiChoice } from '../fields/quiz-multi-choice/quiz-multi-choice-preview';
import { formatQuizImageChoice } from '../fields/quiz-image-choice/quiz-image-choice-preview';
import { formatQuizNumber } from '../fields/quiz-number/quiz-number-preview';
import { formatQuizShortText } from '../fields/quiz-short-text/quiz-short-text-preview';
import { formatQuizSingleChoice } from '../fields/quiz-single-choice/quiz-single-choice-preview';
import { formatRadioGroup } from '../fields/radio-group/radio-group-preview';
import { formatDonation } from '../fields/donation/donation-preview';
import { formatTextArea } from '../fields/text-area/text-area-preview';
import { formatTextInput } from '../fields/text-input/text-input-preview';
import { formatUrlInput } from '../fields/url-input/url-input-preview';
import { formatEcomAdditionalInfo } from '../fields/ecom-additional-info/ecom-additional-info-preview';
import { formatFileUpload } from '../fields/file-upload/file-upload-preview/file-upload-preview';
import { formatSignature } from '../fields/signature/signature-preview';
import { formatDatePicker } from '../fields/date-picker/date-picker-preview';
import { formatRatingInput } from '../fields/rating-input/rating-input-preview';
import { formatTags } from '../fields/tags/tags-preview';
import { formatEcomSubscriptionCheckbox } from '../fields/ecom-subscription-checkbox/ecom-subscription-checkbox-preview';
import { formatPaymentInput } from '../fields/payment-input/payment-input-preview';
import { formatFixedPayment } from '../fields/fixed-payment/fixed-payment-preview';
import { formatBookingsAddress } from '../fields/bookings-address/bookings-address-preview';
import { formatBookingsFirstName } from '../fields/bookings-first-name/bookings-first-name-preview';
import { formatBookingsLastName } from '../fields/bookings-last-name/bookings-last-name-preview';
import { formatBookingsEmail } from '../fields/bookings-email/bookings-email-preview';
import { formatBookingsPhone } from '../fields/bookings-phone/bookings-phone-preview';
import { formatMultilineAddress } from '../fields/multiline-address/multiline-address-preview';
import { formatAppointment } from '../fields/appointment/appointment-preview';
import { formatServiceDropdown } from '../fields/service-dropdown/service-dropdown-preview';
import { formatServicesMultiChoice } from '../fields/services-multi-choice/services-multi-choice-preview';
import { formatEventsRsvp } from '../fields/events-rsvp/events-rsvp-preview';
export { getFormFieldLabel } from '../utils/get-form-field-label';
export const FIELD_PREVIEWS = {
  [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: formatEcomAdditionalInfo,
  [FIELD_TYPES.CONTACTS_COMPANY]: formatContactsCompany,
  [FIELD_TYPES.CONTACTS_POSITION]: formatContactsPosition,
  [FIELD_TYPES.CONTACTS_TAX_ID]: formatContactsTaxId,
  [FIELD_TYPES.CONTACTS_FIRST_NAME]: formatContactsFirstName,
  [FIELD_TYPES.CONTACTS_LAST_NAME]: formatContactsLastName,
  [FIELD_TYPES.CONTACTS_ADDRESS]: formatContactsAddress,
  [FIELD_TYPES.CONTACTS_EMAIL]: formatContactsEmail,
  [FIELD_TYPES.CONTACTS_BIRTHDATE]: formatContactsBirthdate,
  [FIELD_TYPES.CONTACTS_PHONE]: formatContactsPhone,
  [FIELD_TYPES.CONTACTS_SUBSCRIBE]: formatContactsSubscribe,
  [FIELD_TYPES.TEXT_INPUT]: formatTextInput,
  [FIELD_TYPES.TEXT_AREA]: formatTextArea,
  [FIELD_TYPES.CHECKBOX]: formatCheckbox,
  [FIELD_TYPES.CHECKBOX_GROUP]: formatCheckboxGroup,
  [FIELD_TYPES.RADIO_GROUP]: formatRadioGroup,
  [FIELD_TYPES.DATE_INPUT]: formatDateInput,
  [FIELD_TYPES.DATE_TIME_INPUT]: formatDateTimeInput,
  [FIELD_TYPES.TIME_INPUT]: formatTimeInput,
  [FIELD_TYPES.DATE_PICKER]: formatDatePicker,
  [FIELD_TYPES.DROPDOWN]: formatDropdown,
  [FIELD_TYPES.URL_INPUT]: formatUrlInput,
  [FIELD_TYPES.NUMBER_INPUT]: formatNumberInput,
  [FIELD_TYPES.QUIZ_MULTI_CHOICE]: formatQuizMultiChoice,
  [FIELD_TYPES.QUIZ_IMAGE_CHOICE]: formatQuizImageChoice,
  [FIELD_TYPES.QUIZ_SINGLE_CHOICE]: formatQuizSingleChoice,
  [FIELD_TYPES.QUIZ_SHORT_TEXT]: formatQuizShortText,
  [FIELD_TYPES.QUIZ_LONG_TEXT]: formatQuizLongText,
  [FIELD_TYPES.QUIZ_NUMBER]: formatQuizNumber,
  [FIELD_TYPES.QUIZ_FILE_UPLOAD]: notImplemented,
  [FIELD_TYPES.FILE_UPLOAD]: formatFileUpload,
  [FIELD_TYPES.MULTILINE_ADDRESS]: formatMultilineAddress,
  [FIELD_TYPES.NESTED_FORM]: notImplemented,
  [FIELD_TYPES.MLA_COUNTRY]: notImplemented,
  [FIELD_TYPES.MLA_CITY]: notImplemented,
  [FIELD_TYPES.MLA_ADDRESS_LINE]: notImplemented,
  [FIELD_TYPES.MLA_ADDRESS_LINE_2]: notImplemented,
  [FIELD_TYPES.MLA_POSTAL_CODE]: notImplemented,
  [FIELD_TYPES.MLA_SUBDIVISION]: notImplemented,
  [FIELD_TYPES.MLA_STREET_NAME]: notImplemented,
  [FIELD_TYPES.MLA_STREET_NUMBER]: notImplemented,
  [FIELD_TYPES.MLA_APARTMENT]: notImplemented,
  [FIELD_TYPES.FULL_NAME]: notImplemented,
  [FIELD_TYPES.FULL_NAME_FIRST_NAME]: notImplemented,
  [FIELD_TYPES.FULL_NAME_LAST_NAME]: notImplemented,
  [FIELD_TYPES.VAT_ID]: notImplemented,
  [FIELD_TYPES.DEXT_TEXT_INPUT]: notImplemented,
  [FIELD_TYPES.DEXT_TEXT_AREA]: notImplemented,
  [FIELD_TYPES.DEXT_DROPDOWN]: notImplemented,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: notImplemented,
  [FIELD_TYPES.DEXT_URL_INPUT]: notImplemented,
  [FIELD_TYPES.DEXT_EMAIL]: notImplemented,
  [FIELD_TYPES.DEXT_PHONE]: notImplemented,
  [FIELD_TYPES.DEXT_NUMBER_INPUT]: notImplemented,
  [FIELD_TYPES.DEXT_CHECKBOX]: notImplemented,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: notImplemented,
  [FIELD_TYPES.DEXT_RATING_INPUT]: formatRatingInput,
  [FIELD_TYPES.DEXT_DATE_PICKER]: formatDatePicker,
  [FIELD_TYPES.DEXT_TAGS]: formatTags,
  [FIELD_TYPES.ECOM_ADDRESS]: notImplemented,
  [FIELD_TYPES.ECOM_FULL_NAME]: notImplemented,
  [FIELD_TYPES.ECOM_PHONE]: formatEcomPhone,
  [FIELD_TYPES.ECOM_COMPANY_NAME]: formatEcomCompanyName,
  [FIELD_TYPES.ECOM_SUBSCRIPTION]: formatEcomSubscriptionCheckbox,
  [FIELD_TYPES.ECOM_EMAIL]: formatEcomEmail,
  [FIELD_TYPES.SIGNATURE]: formatSignature,
  [FIELD_TYPES.PRODUCT_LIST]: notImplemented,
  [FIELD_TYPES.DONATION]: formatDonation,
  [FIELD_TYPES.RATING_INPUT]: formatRatingInput,
  [FIELD_TYPES.TAGS]: formatTags,
  [FIELD_TYPES.PAYMENT_INPUT]: formatPaymentInput,
  [FIELD_TYPES.FIXED_PAYMENT]: formatFixedPayment,
  [FIELD_TYPES.BOOKINGS_FIRST_NAME]: formatBookingsFirstName,
  [FIELD_TYPES.BOOKINGS_LAST_NAME]: formatBookingsLastName,
  [FIELD_TYPES.BOOKINGS_EMAIL]: formatBookingsEmail,
  [FIELD_TYPES.BOOKINGS_PHONE]: formatBookingsPhone,
  [FIELD_TYPES.BOOKINGS_ADDRESS]: formatBookingsAddress,
  [FIELD_TYPES.APPOINTMENT]: formatAppointment,
  [FIELD_TYPES.IDENTITY_PASSWORD]: notImplemented,
  [FIELD_TYPES.SERVICES_DROPDOWN]: formatServiceDropdown,
  [FIELD_TYPES.SERVICES_MULTI_CHOICE]: formatServicesMultiChoice,
  [FIELD_TYPES.EVENTS_RSVP]: formatEventsRsvp
};
function notImplemented() {
  return undefined;
}
//# sourceMappingURL=preview.js.map